export enum PartySource {
  noSource = 0,
  manager,
  public,
  api,
  square,
  sms,
  google,
}
